<template>
  <div class="app-container">
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
      <h3>商品分类</h3>
      <el-row>
        <el-col :span="8">
          <el-form-item class="w500" prop="cate_uuid" label="分类">
            <el-select v-model="ruleForm.cate_uuid" placeholder="请选择分类">
              <el-option v-for="(item, index) in classList" :key="index" :label="item.title" :value="item.uuid">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <h3>基本信息</h3>
      <!-- <el-form-item label="所属商圈" prop="name">
                <el-select v-model="ruleForm.campus" multiple>
                    <el-option label="a" value="a"></el-option>
                    <el-option label="a" value="b"></el-option>
                    <el-option label="a" value="b"></el-option>
                </el-select>
            </el-form-item> -->
      <el-row>
        <el-col :span="8">
          <el-form-item label="商品标题" prop="title">
            <el-input v-model="ruleForm.title"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="商品库存" prop="stock">
            <el-input v-model="ruleForm.stock"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="商品价格" prop="price">
            <el-input v-model="ruleForm.price"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <h3>图文介绍</h3>
      <!-- <el-form-item label="商品图片" prop="thumb">

                <imgUpload
                    v-model="ruleForm.thumb"
                    component-id="img"

                    :limit="8"
                ></imgUpload>

            </el-form-item> -->
      <el-form-item label="商品图片" prop="thumb">
        <imgUpload v-model="ruleForm.thumb" component-id="'img" :limit="8"></imgUpload>
      </el-form-item>
      <el-form-item label="详情介绍" prop="desc">
        <fulledit v-model="ruleForm.desc"></fulledit>
      </el-form-item>
      <el-form-item label="售后说明" prop="after_sale">
        <fulledit v-model="ruleForm.after_sale"></fulledit>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <el-button @click="$router.go(-1)">返回</el-button>
      </el-form-item>
    </el-form>

    <!-- <el-dialog title="收货地址" :visible.sync="dialogTableVisible">
          <el-table :data="gridData">
            <el-table-column property="date" label="日期" width="150"></el-table-column>
            <el-table-column property="name" label="姓名" width="200"></el-table-column>
            <el-table-column property="address" label="地址"></el-table-column>
          </el-table>
        </el-dialog> -->
  </div>
</template>

<script>
import areaSelect from "@/components/pub/areaSelect.vue";
import imgUpload from "@/components/pub/imgUploadNormal.vue";
import imgUploads from "@/components/pub/supperUpload.vue";
import fulledit from "@/components/pub/fulledit.vue";
import { GoodDetail, addGood, editGood } from "@/api/product.js";
import { getCate } from "@/api/product.js";
export default {
  components: {
    imgUpload,
    areaSelect,
    imgUploads,
    fulledit,
  },
  data() {
    return {
      ruleForm: {},
      classList: [],
      form: {},
      query: {},
      rules: {
        stock: [
          {
            required: true,
            message: "请输入商品库存",
            trigger: "blur",
          },
        ],
        title: [
          {
            required: true,
            message: "请输入商品名称",
            trigger: "blur",
          },
        ],
        price: [
          {
            required: true,
            message: "请输入价格",
            trigger: "blur",
          },
        ],
        desc: [
          {
            required: true,
            message: "请输入详情",
            trigger: "blur",
          },
        ],
        after_sale: [
          {
            required: true,
            message: "请输入售后说明",
            trigger: "blur",
          },
        ],
        cate_uuid: [
          {
            required: true,
            message: "请选择分类",
            trigger: "change",
          },
        ],
        thumb: [
          {
            required: true,
            message: "请上传图片",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {
    const uuid = this.$route.query.uuid;
    this.query = this.$route.query;
    if (uuid) {
      this.getDetail(uuid);
    }
    this.getClassList();
  },
  methods: {
    async getClassList() {
      const res = await getCate({ status: 2 });
      if (res.data instanceof Array) {
        this.classList = res.data;
      }
    },
    async getDetail(uuid) {
      const res = await GoodDetail(uuid);
      console.log(res);
      if (res) {
        this.ruleForm = res;
        this.ruleForm.account = res.admin ? res.admin.account : "";
        this.ruleForm.group_id = res.admin ? res.admin.group_id : "";
        this.ruleForm.area = [res.province_id, res.area_id, res.city_id];
      }
    },
    subEdit() {
      editGood(this.ruleForm, this.query.uuid).then((res) => {
        if (res) {
          this.$message.success("成功");
          this.$router.go(-1);
        }
      });
    },
    subAdd() {
      addGood(this.ruleForm).then((res) => {
        if (res) {
          this.$message.success("成功");
          this.$router.go(-1);
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.query.uuid) {
            this.subEdit();
          } else {
            this.subAdd();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style></style>
